module.exports = __webpack_public_path__ + "a6ad13254e8c9d34f291295a57c5ed84.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader!./src/img/cursor-hand.png
// module id = 2389
// module chunks = 0